


















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class DialogPage extends Vue {
    @Prop({ type: Boolean, required: false, default: true }) public canClose!: boolean;
}
